/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Finals_TimeInputs */



/**
* | output |
* | --- |
* | "Finals time" |
*
* @param {Timer_Finals_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_finals_time = /** @type {((inputs?: Timer_Finals_TimeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Finals_TimeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de final")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tempo de final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo della finale")
	return /** @type {LocalizedString} */ ("Finals time")
});